"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoAddParticipant = autoAddParticipant;
exports.createTraining = createTraining;
exports.deleteTrainingById = deleteTrainingById;
exports.getTeamAndUserTraining = getTeamAndUserTraining;
exports.getTrainingById = getTrainingById;
exports.getTrainingList = getTrainingList;
exports.getTrainingManagerReportRecipients = getTrainingManagerReportRecipients;
exports.getTrainingStaff = getTrainingStaff;
exports.getTrainingTeams = getTrainingTeams;
exports.getUserTraining = getUserTraining;
exports.sendManagerReport = sendManagerReport;
exports.unenrolParticipant = unenrolParticipant;
exports.updateTrainingById = updateTrainingById;
exports.updateTrainingManagerReportRecipients = updateTrainingManagerReportRecipients;
var _request = _interopRequireDefault(require("@/utils/request"));
function getTrainingList(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/trainings',
    method: 'get',
    headers,
    params: query
  });
}
function getTrainingById(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/trainings/' + id,
    method: 'get',
    headers
  });
}
function getTrainingTeams(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/trainings/' + id + '/teams',
    method: 'get',
    headers
  });
}
function getTrainingStaff(token, id, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/trainings/' + id + '/staff',
    method: 'get',
    headers,
    params: query
  });
}
function getTrainingManagerReportRecipients(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/manager-report/trainings/' + id,
    method: 'get',
    headers
  });
}
function updateTrainingManagerReportRecipients(token, id, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/manager-report/trainings/' + id,
    method: 'post',
    headers,
    data
  });
}
function createTraining(token, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/trainings',
    method: 'post',
    headers,
    data
  });
}
function updateTrainingById(token, id, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/trainings/' + id,
    method: 'put',
    headers,
    data
  });
}
function deleteTrainingById(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/trainings/' + id,
    method: 'delete',
    headers
  });
}
function sendManagerReport(token, trainingId, email, participants) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = {
    trainingId,
    participants,
    email
  };
  return (0, _request.default)({
    url: '/user-statistics/coach/manager-report',
    method: 'post',
    headers,
    data
  });
}
function autoAddParticipant(token, account) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const res = (0, _request.default)({
    url: '/user-trainings/register-enroll',
    method: 'post',
    headers,
    data: account
  });
  return res;
}
function getUserTraining(token, userUUid) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const query = {
    page: 1,
    sort: '-createdAt',
    user: userUUid,
    limit: 100,
    populate: false
  };
  const res = (0, _request.default)({
    url: '/user-trainings',
    method: 'get',
    headers
  });
  return res;
}
function getTeamAndUserTraining(token, trainingId) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const res = (0, _request.default)({
    url: `/trainings/${trainingId}/teamsWithUserTraining`,
    method: 'get',
    headers
  });
  return res;
}
function unenrolParticipant(token, trainingId, userUuid) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const res = (0, _request.default)({
    url: `/coach-tools/trainings/${trainingId}/users/${userUuid}/unenroll`,
    method: 'delete',
    headers
  });
  return res;
}